module.exports = __webpack_public_path__ + "static/img/116.dd34d21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/116.jpg
// module id = qtgI
// module chunks = 0